import { takeLatest, call, put } from 'redux-saga/effects';
import AggregateSearchApi from '../api/aggregateSearch';
import {
    FETCH_AGGREGATE_FILTERS,
    fetchAggregateFiltersSuccess,
    fetchAggregateFiltersFail,
} from '../actions/aggregateFilters';
import { buildAggregateRequestBody, mapResponseToOptions } from '../helpers/search/AggregateSearchHelper';
import ApiHelper from '../helpers/ApiHelper';
import Bugsnag from '../bugsnag';

/**
 * Saga that fetches aggregate filter options from the API.
 * Uses takeLatest to cancel the saga task when filters change rapidly.
 * Note: takeLatest cancels the saga generator but does not abort the
 * underlying HTTP request — the network call may still complete in
 * the background. This is acceptable because the response from a
 * stale request is simply discarded (the saga is no longer running
 * to dispatch the result).
 */
export function* fetchAggregateFiltersSaga(action) {
    try {
        const { flatFilters } = action.payload;
        // Reuse ApiHelper.buildRequest to convert flat filters into the structured
        // { field, operation, value } format the aggregate API expects.
        const { filters: structuredFilters } = ApiHelper.buildRequest(flatFilters);
        const requestBody = buildAggregateRequestBody(structuredFilters);
        const response = yield call(AggregateSearchApi.fetchAggregateSearch, requestBody);

        if (response && response.data) {
            const options = mapResponseToOptions(response.data);
            yield put(fetchAggregateFiltersSuccess(options));
        } else {
            yield put(fetchAggregateFiltersFail({ message: 'No data in aggregate response' }));
        }
    } catch (error) {
        Bugsnag.notify(error);
        yield put(fetchAggregateFiltersFail(error));
    }
}

function* watchFetchAggregateFilters() {
    yield takeLatest(FETCH_AGGREGATE_FILTERS, fetchAggregateFiltersSaga);
}

export default [
    watchFetchAggregateFilters(),
];
